<template>
    <div>
        <rkm-table
            :fields="fields"
            :items="data.model.sigilos.filter(sigilo => sigilo.deleted === false)"
        >
            <template v-slot:cell(ocupacao)="{item}">
                {{item.ocupacao.codigo}} - {{item.ocupacao.nome}}
            </template>

            <template v-slot:cell(unidadeNomeFantasia)="{item}">
                {{item.unidadeNomeFantasia ? item.unidadeNomeFantasia : '-'}}
            </template>

            <template v-slot:cell(infraestruturaNome)="{item}">
                {{item.infraestruturaNome ? item.infraestruturaNome : '-'}}
            </template>

            <template v-slot:cell(actions)="{index, item}">
                <rkm-button
                    @click="$refs.ModalInfraestrutura.open(item)"
                    color="info"
                    small
                    title="Permissão de visualização para o local de atendimento"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="$refs.ModalOcupacao.open(item)"
                    color="primary"
                    small
                    title="Permissão de visualização para o CBO"
                >
                    <rkm-icon icon="cog" />
                </rkm-button>

                <rkm-button
                    @click="destroy(index)"
                    color="danger"
                    small
                    title="Excluir"
                >
                    <rkm-icon icon="trash" />
                </rkm-button>
            </template>
        </rkm-table>

        <ModalInfraestrutura
            :data="data"
            ref="ModalInfraestrutura"
        />

        <ModalOcupacao ref="ModalOcupacao" />
    </div>
</template>

<script>
// Components.
import ModalInfraestrutura from './components/infraestrutura/Modal'
import ModalOcupacao from './components/ocupacao/Modal'

export default {
    components: {
        ModalInfraestrutura,
        ModalOcupacao,
    },
    data: () => ({
        fields: [
            {key: 'ocupacao', label: 'CBO'},
            {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
            {key: 'infraestruturaNome', label: 'Local de atendimento', sortable: true},
            {key: 'sigiloTipoNome', label: 'Tipo de sigilo'},
            {key: 'actions', label: 'Ações', class: 'col-min text-center'},
        ],
    }),
    methods: {
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o sigilo?', async () => {
                this.data.model.sigilos[index].deleted = true
            })
        },
    },
    props: {
        data: {type: Object, required: true},
    },
}
</script>